import type { AttachmentDto, ImportNotesInput, ImportNotesResultDto } from '@keep/shared';
import { api } from '../lib/api';

/** Appels de l'API d'import (utilisés par features/import/run-import.ts). */
export const importApi = {
  importBatch: (input: ImportNotesInput) => api.post<ImportNotesResultDto>('/import/notes', input),
  uploadImage: (noteId: string, file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.post<AttachmentDto>(`/import/notes/${noteId}/attachments`, form);
  },
};
